import { convert } from './fx';

// Suma una lista de objetos { amount, currency } en una divisa de destino.
// Soporta también shapes legacy: número plano (asume USD) o publicación
// completa con `price.amount` / `price.currency`.
export default function sumInCurrency(items, displayCurrency, rates) {
  if (!Array.isArray(items)) return 0;
  return items.reduce((acc, raw) => {
    if (raw == null) return acc;
    let amount, currency;
    if (typeof raw === 'number') { amount = raw; currency = 'USD'; }
    else if (raw.price && typeof raw.price === 'object') {
      amount = Number(raw.price.amount) || 0;
      currency = raw.price.currency || 'USD';
    } else if (typeof raw === 'object') {
      amount = Number(raw.amount) || 0;
      currency = raw.currency || 'USD';
    } else {
      return acc;
    }
    if (!amount) return acc;
    return acc + convert(amount, currency, displayCurrency || currency, rates);
  }, 0);
}
